import { UserManager, WebStorageStateStore } from 'oidc-client-ts';

export type KeycloakAuth = {
  signIn(): Promise<void>;
  handleCallback(): Promise<string>;
  refresh(): Promise<string | null>;
  signOut(): Promise<void>;
};

export function createKeycloakAuth(issuer: string, clientId: string) {
  const userManager = new UserManager({
    authority: issuer,
    client_id: clientId,
    redirect_uri: `${window.location.origin}/auth/callback`,
    post_logout_redirect_uri: window.location.origin,
    scope: 'openid profile email',
    userStore: new WebStorageStateStore({ store: window.localStorage }),
    automaticSilentRenew: false,
  });

  return {
    signIn: () => userManager.signinRedirect(),
    handleCallback: async () => {
      const user = await userManager.signinRedirectCallback();

      return user.access_token;
    },
    refresh: async () => {
      const user = await userManager.signinSilent();

      return user?.access_token ?? null;
    },
    signOut: () => userManager.signoutRedirect(),
  };
}
